import { createContext, useContext } from 'react';

export const PopupNotificationContext = createContext();

export const usePopupNotification = () => {
    return useContext(PopupNotificationContext);
};